import * as React from 'react';
import MediaQuery from 'react-responsive';
import {Shop} from 'interfaces';
import {withI18n, WithI18nProps} from 'packages/@shopify/react-i18n';
import * as locales from './locales';
import ShopRow from './components/ShopRow';

export interface ShopTableProps {
  shops: Shop[];
}

const style = {
  header: {
    industry: 'text-minor shop-row__industry-header',
    inventory: 'text-minor',
    price: 'text-minor shop-row__price-header',
    profits: 'text-minor shop-row__profits-header',
    revenue: 'text-minor shop-row__stats-header',
    title: 'text-minor shop-row__title-header',
    traffic: 'text-minor shop-row__stats-header',
  },
  monthlyAverages: 'text-minor text-right',
  table: 'marketing-table shop-table',
  wrapper: 'grid__item gutter-bottom--half',
};

type ComposedProps = WithI18nProps & ShopTableProps;

function ShopTableComponent({shops, i18n}: ComposedProps) {
  return (
    <div className={style.wrapper}>
      <MediaQuery query="(max-width: 1432px)">
        {(matches) => {
          return (
            <table className={style.table}>
              <thead>
                <tr>
                  {matches ? null : <th />}
                  <th className={style.header.title}>{i18n.translate('header.title')}</th>
                  {matches ? null : <th className={style.header.industry}>{i18n.translate('header.industry')}</th>}

                  <th className={style.header.revenue}>
                    {i18n.translate('header.revenue')}
                    {` (${i18n.translate('usd')})`}
                  </th>

                  <th className={style.header.traffic}>{i18n.translate('header.traffic')}</th>

                  <th className={style.header.profits}>
                    {i18n.translate('header.profits')}
                    {` (${i18n.translate('usd')})`}
                  </th>

                  {matches ? null : <th className={style.header.inventory}>{i18n.translate('header.inventory')}</th>}
                  <th className={style.header.price}>{i18n.translate('header.price')}</th>
                </tr>
              </thead>
              <tbody>
                {shops.map((item) => (
                  <ShopRow
                    key={item.handle}
                    shop={item}
                    shortenRow={matches}
                  />
                ))}
              </tbody>
            </table>
          );
        }}
      </MediaQuery>
    </div>
  );
}

const ShopTable = withI18n({
  id: 'ShopTable',
  fallback: locales.en,
})(ShopTableComponent);

export {ShopTable, ShopTableComponent};
export default ShopTable;
